import { render, staticRenderFns } from "./ProjectInstance.vue?vue&type=template&id=388f06c5&scoped=true&"
import script from "./ProjectInstance.vue?vue&type=script&lang=js&"
export * from "./ProjectInstance.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInstance.vue?vue&type=style&index=0&id=388f06c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388f06c5",
  null
  
)

export default component.exports